// removed by extract-text-webpack-plugin
module.exports = {"closeIcon":"textMediaSection__closeIcon--3CVvM","closeButton":"textMediaSection__closeButton--3f-n0","closeButtonActive":"textMediaSection__closeButtonActive--1GM-b textMediaSection__closeButton--3f-n0","closeButtoInactive":"textMediaSection__closeButtoInactive--1r2Zs textMediaSection__closeButton--3f-n0","videoActive":"textMediaSection__videoActive--1p_iH","ytVideo":"textMediaSection__ytVideo--3zXI5","pauseYTButton":"textMediaSection__pauseYTButton--33BUD","videoWrapper":"textMediaSection__videoWrapper--yYwf3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/TextMediaSection/textMediaSection.css
// module id = 5feS
// module chunks = 0